import React from "react";
import img from "../../../Assets/Homeimgs/share.svg";
import right from "../../../Assets/Homeimgs/Right.svg";

const WantToShare = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white">
      {/* Glow Orbs */}
      <div className="pointer-events-none absolute -top-32 -left-32 h-80 w-80 rounded-full bg-[#064585]/25 blur-3xl" />
      <div className="pointer-events-none absolute top-40 -right-32 h-96 w-96 rounded-full bg-[#5989C8]/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-8 md:py-12 lg:py-14 flex flex-col lg:flex-row gap-10 lg:gap-12 items-center">
        {/* Left Illustration */}
        <div className="md:w-2/5 flex justify-center" data-aos="fade-right">
          <div className="bg-white/70 backdrop-blur-lg border border-[#5989C8]/20 rounded-3xl shadow-md p-6 flex justify-center">
            <img
              src={img}
              alt="Mentor Illustration"
              className="w-full max-w-md"
            />
          </div>
        </div>

        {/* Right Content */}
        <div className="md:w-1/2" data-aos="fade-left">
          <p className="text-[10px] sm:text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-[#064585]">
            Teach & Inspire
          </p>

          <h1 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-semibold leading-tight text-slate-900">
            Want to share your{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
              Knowledge?
            </span>
          </h1>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#02183F] mt-2 tracking-wide">
            Join us as a Mentor!
          </h2>

          <p
            className="mt-4 text-slate-600 text-sm sm:text-base leading-relaxed"
            data-aos="zoom-in"
          >
            Share your expertise, inspire learners, and become a mentor in our
            growing community. Guide students with real-world skills while
            enhancing your professional journey.
          </p>

          {/* Features List */}
          <ul
            className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4"
            data-aos="zoom-in-up"
          >
            {[
              "Teach Students",
              "Earn Incentives",
              "Professional Growth",
              "Rewarding Experience",
            ].map((item, idx) => (
              <li
                key={idx}
                className="flex items-center text-gray-800 text-base font-medium"
              >
                <img src={right} alt="check" className="mr-3 w-5 h-5" />
                {item}
              </li>
            ))}
          </ul>

          {/* Button */}
          <button
            className="mt-8 bg-gradient-to-r from-[#5989C8] to-[#064585] text-white py-3 px-8 rounded-full text-lg font-semibold shadow-md hover:shadow-lg transition"
            data-aos="zoom-in-down"
          >
            Join as a Mentor
          </button>
        </div>
      </div>
    </section>
  );
};

export default WantToShare;
